import React from 'react'
import Menu from '../../component/Menu'
import Integrations from '../../component/Integrations/Integrations'

const Integration = () => {
    return (
        <>
            <Menu logic={<Integrations/>} page={"Integrations"} /> 
        </> 
    )
}

export default Integration